var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"simple-spinner",style:(_vm.getStyle)},[_c('div',{staticClass:"icon"})])
}
var staticRenderFns = []

export { render, staticRenderFns }